import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "music_play" };
import { reactive, onMounted, onUnmounted, computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import emitter from '../../utils/eventBus';
import loginView from '../login/login.vue';
import musicChat from '../subview/music/music_chat/music_chat.vue';
import headerView from './components/header.vue';
import sidebar from './components/sidebar.vue';
import { useStore } from 'vuex';
import { deviceUtils } from '@/utils/device';
// 导入简化版软键盘工具
import { SoftKeyboardHelper } from '@/utils/softKeyboardHelper';
const ANDROID_TABLET_PORTRAIT_KEYBOARD_EXTRA_HEIGHT = 56;
const ANDROID_TABLET_LANDSCAPE_KEYBOARD_EXTRA_HEIGHT = 112;
const ANDROID_TABLET_PORTRAIT_FIXED_KEYBOARD_EXTRA_HEIGHT = 30;
const ANDROID_TABLET_LANDSCAPE_FIXED_KEYBOARD_EXTRA_HEIGHT = 10;
const LINUX_AARCH64_LANDSCAPE_BOTTOM_SAFE_HEIGHT = 48;
const LINUX_AARCH64_PORTRAIT_KEYBOARD_EXTRA_HEIGHT = 160;
const LINUX_AARCH64_FIXED_KEYBOARD_EXTRA_HEIGHT = 20;
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();
        const getKeyboardHeightOffset = () => {
            const isPortrait = deviceUtils.isPortraitMode();
            if (deviceUtils.isLinuxAarch64()) {
                return isPortrait
                    ? LINUX_AARCH64_PORTRAIT_KEYBOARD_EXTRA_HEIGHT
                    : 0;
            }
            return deviceUtils.isAndroidTablet()
                ? (isPortrait ? ANDROID_TABLET_PORTRAIT_KEYBOARD_EXTRA_HEIGHT : ANDROID_TABLET_LANDSCAPE_KEYBOARD_EXTRA_HEIGHT)
                : 0;
        };
        const getFixedKeyboardHeightOffset = () => {
            const isPortrait = deviceUtils.isPortraitMode();
            if (deviceUtils.isLinuxAarch64()) {
                return LINUX_AARCH64_FIXED_KEYBOARD_EXTRA_HEIGHT;
            }
            return deviceUtils.isAndroidTablet()
                ? (isPortrait ? ANDROID_TABLET_PORTRAIT_FIXED_KEYBOARD_EXTRA_HEIGHT : ANDROID_TABLET_LANDSCAPE_FIXED_KEYBOARD_EXTRA_HEIGHT)
                : 0;
        };
        // === 原有业务逻辑（保持不变） ===
        const showBgRoute = reactive([
            '/new-chat', '/nineHeavens', '/deepseek',
            '/intelligence_list', '/meeting/introduce', '/meeting/audioToText',
            '/simultaneousTranslation/introduce', '/imagecomprehend',
            '/writing', '/drawing'
        ]);
        const showBgRouteDetail = reactive([
            '/meeting/detail', '/meeting/room', '/simultaneousTranslation/generate'
        ]);
        const getRoutePath = computed(() => {
            return showBgRoute.findIndex((el) => el === route.fullPath) !== -1 || showBgRouteDetail.includes(route.path);
        });
        const handleCollapse = () => {
            store.commit('handleCollapse', !store.state.isCollapse);
        };
        const playMusic = (value) => {
            showPlay.value = true;
            musicChatInfo.value = value;
        };
        // === 页面状态变量 ===
        const showPlay = ref(false);
        const musicChatInfo = ref();
        const isCollapse = computed(() => {
            return store.state.isCollapse;
        });
        // === 软键盘相关状态（极简，直接接收更新） ===
        const keyboardHeight = ref(0);
        const isKeyboardShow = ref(false);
        const viewportHeight = ref(window.innerHeight || document.documentElement.clientHeight);
        const isKeyboardAdaptDevice = computed(() => {
            return store.state.isMobile || deviceUtils.shouldAdaptSoftKeyboard();
        });
        // === 初始化简化版软键盘工具 ===
        const keyboardHelper = new SoftKeyboardHelper((status) => {
            const nextKeyboardHeight = Math.round(status.height || 0);
            const nextViewportHeight = Math.round(status.viewportHeight || window.innerHeight);
            if (isKeyboardShow.value !== status.isShown) {
                isKeyboardShow.value = status.isShown;
            }
            if (keyboardHeight.value !== nextKeyboardHeight) {
                keyboardHeight.value = nextKeyboardHeight;
                store.commit('setKeyboard', nextKeyboardHeight);
            }
            if (viewportHeight.value !== nextViewportHeight) {
                viewportHeight.value = nextViewportHeight;
            }
        }, {
            isPad: deviceUtils.shouldAdaptSoftKeyboard(),
            keyboardHeightOffset: getKeyboardHeightOffset(),
            fixedKeyboardHeightOffset: getFixedKeyboardHeightOffset(),
            enableDebug: false
        });
        // === 布局相关计算属性 ===
        const layoutDynamicHeight = computed(() => {
            return isKeyboardAdaptDevice.value || isKeyboardShow.value
                ? `${Math.round(viewportHeight.value)}px`
                : '100vh';
        });
        const isLinuxAarch64Landscape = computed(() => {
            return deviceUtils.isLinuxAarch64() && !store.state.isPortrait;
        });
        const getMainHeight = computed(() => {
            const bottomSafeHeight = isLinuxAarch64Landscape.value && !isKeyboardShow.value
                ? `${LINUX_AARCH64_LANDSCAPE_BOTTOM_SAFE_HEIGHT}px`
                : '0px';
            return `calc(100% - 0px - 22px - ${bottomSafeHeight})`;
        });
        // === 生命周期钩子（仅初始化/销毁工具） ===
        onMounted(() => {
            // 初始化音乐事件
            emitter.on('closeMusic', () => {
                showPlay.value = false;
                musicChatInfo.value = '';
            });
            emitter.on('playMusic', e => {
                playMusic(e);
            });
            // 初始化软键盘监听（开启指定元素监听）
            keyboardHelper.init();
        });
        watch(() => [store.state.isPad, store.state.isMobile, store.state.isPortrait], () => {
            keyboardHelper.updateConfig({
                isPad: deviceUtils.shouldAdaptSoftKeyboard(),
                keyboardHeightOffset: getKeyboardHeightOffset(),
                fixedKeyboardHeightOffset: getFixedKeyboardHeightOffset()
            });
        }, { immediate: true });
        onUnmounted(() => {
            // 销毁音乐事件
            emitter.off('closeMusic');
            emitter.off('playMusic');
            // 销毁软键盘监听（释放资源）
            keyboardHelper.destroy();
        });
        // === 路由监听（保持不变，无冗余代码） ===
        let isRouteChanging = false;
        router.beforeEach((to, from, next) => {
            isRouteChanging = true;
            next();
        });
        router.afterEach(() => {
            setTimeout(() => {
                isRouteChanging = false;
            }, 300);
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["layout flexRow", { 'layout-mobile': _unref(store).state.isMobile, 'layout-pad': _unref(store).state.isPad }]),
                style: _normalizeStyle({ height: layoutDynamicHeight.value })
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["layout_sidebar", { 'layout_sidebar_collapse': isCollapse.value }])
                }, [
                    _createVNode(sidebar)
                ], 2),
                _createVNode(_Transition, { name: "el-fade-in-linear" }, {
                    default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", {
                            class: "layout_overlay",
                            onClick: handleCollapse
                        }, null, 512), [
                            [_vShow, _unref(store).state.isMobile && isCollapse.value]
                        ])
                    ]),
                    _: 1
                }),
                _createElementVNode("div", {
                    class: _normalizeClass(["pgFlex flexColumn layout_main", { layout_setting: _unref(route).name == '/setting', 'pageBg': getRoutePath.value }])
                }, [
                    _createVNode(headerView),
                    _createElementVNode("div", {
                        class: "main flexColumn",
                        style: _normalizeStyle({ height: getMainHeight.value })
                    }, [
                        _createVNode(_Transition, { name: "el-fade-in" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_router_view)
                            ]),
                            _: 1
                        })
                    ], 4),
                    _cache[0] || (_cache[0] = _createElementVNode("div", {
                        class: "flexRow-alc flex-jcc ft12",
                        style: { "padding-bottom": "4px", "color": "#ccc" }
                    }, [
                        _createElementVNode("span", null, "内容由AI生成，仅供参考")
                    ], -1)),
                    _createVNode(_Transition, { name: "el-fade-in-linear" }, {
                        default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", _hoisted_1, [
                                _createVNode(musicChat, _normalizeProps(_guardReactiveProps(musicChatInfo.value)), null, 16)
                            ], 512), [
                                [_vShow, showPlay.value]
                            ])
                        ]),
                        _: 1
                    })
                ], 2),
                _createVNode(loginView)
            ], 6));
        };
    }
});
